import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import { IoIosArrowUp, IoIosArrowDown } from 'react-icons/io';
import { IDngrEvalFile, IDngrEvalMainDtl } from '../../interface/Interface';
import hall1 from '../../images/place/ueco_hall.jpg';
// import hall2 from '../../images/place/dcc_hall2.jpg';
import { Tooltip } from "react-tooltip";
const $ = require("jquery")

export default function DngrEvalDetail({ wrkDclrSeq, setTab }: any) {

  const [mainDtlData, setMainDtlData] = useState<IDngrEvalMainDtl>();
  const [fileDataList, setFileDataList] = useState<IDngrEvalFile[]>();
  const [fldAgntDataList, setFldAgntDataList] = useState([]);
  const [wrkrInfoDataList, setWrkrInfoDataList] = useState([]);
  const [dngrEvalDataList, setDngrEvalDataList] = useState([]);
  const [apprMemo, setApprMemo] = useState('');

  const [isExhibition, setIsExhibition] = useState(false);
  const [viewWrkDclrHist, setViewWrkDclrHist] = useState(true);
  const [viewCnstrCmpny, setViewCnstrCmpny] = useState(true);
  const [viewFldAgnt, setViewFldAgnt] = useState(true);
  const [viewWrkrList, setViewWrkrList] = useState(true);
  const [viewWrkCntns, setViewWrkCntns] = useState(true);
  const [viewMemo, setViewMemo] = useState(true);

  const [placeSrc, setPlaceSrc] = useState<string>();
  const mapRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    console.log('dngrEvalDataList: ', dngrEvalDataList);
  }, [dngrEvalDataList])

  useEffect(() => {
    $("#dngr-eval-detail-area").on("scroll", function () {
      if (mapRef && mapRef.current) {
        var width = mapRef.current.getBoundingClientRect().width
        var height = mapRef.current.getBoundingClientRect().height
        var maxCellXCount = 30
        var maxCellYCount = 30
        var stepCellXCount = width / maxCellXCount
        var stepCellYCount = height / maxCellYCount
        var points = $("[data-ge-place-point='true']")
        $.each(points, function (index: number, elem: any) {
          var x = $(elem).data("work-plc-x")
          if(x != 30){
            x = x + 1
          }
          var y = $(elem).data("work-plc-y")
          var left = stepCellXCount * x - (stepCellXCount / 2)
          var top = stepCellYCount * y - (stepCellYCount / 2)
          $(elem).css("display", "")
          $(elem).css("left", left)
          $(elem).css("top", top)
          //alert(width + " / " + height + " / " + left + " / " + top)
        })
      }
    })
    setPlaceSrc(hall1)
  }, [])
  useEffect(() => {
    if (mainDtlData) {
      var exbtPlcNm = mainDtlData.exbtPlcNm
      if (exbtPlcNm.indexOf("1") > -1) {
        setPlaceSrc(hall1)
      } else {
        setPlaceSrc(hall1)
      }
    }
  }, [mainDtlData])

  useEffect(() => {
    fn_retrieveDngrEvalDtl({ wrkDclrSeq, setFldAgntDataList, setWrkrInfoDataList, setMainDtlData, setFileDataList, setDngrEvalDataList, setIsExhibition, setApprMemo });
  }, [wrkDclrSeq]);

  return (
    <div id={"dngr-eval-detail-area"} className='h-[calc(100%-52px)] md:h-[calc(100%-130px)] overflow-auto scrollbar-hide bg-white text-txtBlack rounded-t-[20px] md:rounded-t-[50px] flex flex-col items-center'>
      <div className='mb-20 md:mb-[50px] w-[260px] sm:w-[318px] md:w-[750px]'>
        <button onClick={() => setViewWrkDclrHist(!viewWrkDclrHist)} className='mt-28 md:mt-[70px] flex justify-between items-center outline-none border-none w-full h-47 md:h-[117px] rounded-[5px] shadow-[0_0_3px_1px_rgba(0,0,0,0.10)]'>
          <div className='flex flex-col justify-center items-start pl-18 md:pl-[45px] w-[155px] sm:w-[210px] md:w-[525px] text-13 sm:text-15 md:text-37 font-preBold'>작업신고 상세 내역</div>
          {!viewWrkDclrHist && <IoIosArrowDown className='mr-18 md:mr-[45px] md:w-[40px] md:h-[40px]' />}
          {viewWrkDclrHist && <IoIosArrowUp className='mr-18 md:mr-[45px] md:w-[40px] md:h-[40px]' />}
        </button>
        {viewWrkDclrHist &&
          <div className='flex mt-20 text-14 md:mt-[50px] md:text-35'>
            <div className='font-preBold'>
              <p className='ml-10 sm:ml-14 md:ml-[35px] mb-15 md:mb-[37px]'>행사명</p>
              <p className='ml-10 sm:ml-14 md:ml-[35px] mb-15 md:mb-[37px] mr-20 md:mr-[50px]'>주최사</p>
              <p className='ml-10 sm:ml-14 md:ml-[35px] mb-15 md:mb-[37px] mr-20 md:mr-[50px]'>참가업체명</p>
              <p className='ml-10 sm:ml-14 md:ml-[35px] mb-15 md:mb-[37px]'>부스 번호</p>
              <p className='ml-10 sm:ml-14 md:ml-[35px] mb-15 md:mb-[37px]'>부스 수</p>
              <p className='ml-10 sm:ml-14 md:ml-[35px] mb-15 md:mb-[37px]'>부스 형태</p>
              <p className='ml-10 sm:ml-14 md:ml-[35px] mb-15 md:mb-[37px]'>업종 분류</p>
              <p className='ml-10 sm:ml-14 md:ml-[35px] mb-15 md:mb-[37px]'>장소</p>
              <p className='ml-10 sm:ml-14 md:ml-[35px] mb-15 md:mb-[37px]'>준비기간</p>
              <p className='ml-10 sm:ml-14 md:ml-[35px] mb-15 md:mb-[37px]'>철거기간</p>
              <p className='ml-10 sm:ml-14 md:ml-[35px] mb-15 md:mb-[37px]'>첨부파일</p>
            </div>
            <div className='font-preLight w-[70%]'>
              <p className='mb-15 md:mb-[37px] truncate'>{mainDtlData?.evntNm}</p>
              <p className='mb-15 md:mb-[37px] truncate'>{mainDtlData?.hstCmpnyNm}</p>
              <p className='mb-15 md:mb-[37px]'>{mainDtlData?.ptcptCmpnyNm}</p>
              <p className='mb-15 md:mb-[37px]'>{mainDtlData?.bthNos}</p>
              <p className='mb-15 md:mb-[37px]'>{mainDtlData?.bthCnt === 0 ? '-' : mainDtlData?.bthCnt}</p>
              <p className='mb-15 md:mb-[37px]'>{mainDtlData?.bthTpNm}</p>
              <p className='mb-15 md:mb-[37px]'>{mainDtlData?.sctrGbNm}</p>
              <p className='mb-15 md:mb-[37px]'>{mainDtlData?.exbtPlcNm}</p>
              <div className='flex items-center mb-15 md:mb-[37px]'><p>{mainDtlData?.cnstrStrtDt}</p><p className='mx-4 md:mx-[10px]'>~</p><p>{mainDtlData?.cnstrEndDt}</p></div>
              <div className='flex items-center mb-15 md:mb-[37px]'><p>{mainDtlData?.dmlnStrtDt}</p><p className='mx-4 md:mx-[10px]'>~</p><p>{mainDtlData?.dmlnEndDt}</p></div>
              {fileDataList?.map((fileData) => (
                <a key={fileData.fileSn} className='underline mb-15 md:mb-[37px]' href={"api/cmmn/fileDownload?atchFileId=" + fileData.atchFileId + "&fileSn=" + fileData.fileSn}>{fileData.orignlFileNm}</a>
              ))}
            </div>
          </div>}
        {isExhibition && <>
          <button onClick={() => setViewCnstrCmpny(!viewCnstrCmpny)} className='mt-10 md:mt-[25px] flex justify-between items-center outline-none border-none w-full h-47 md:h-[117px] rounded-[5px] md:rounded-[12px] shadow-[0_0_3px_1px_rgba(0,0,0,0.10)]'>
            <div className='flex flex-col justify-center items-start pl-18 md:pl-[45px] w-[155px] sm:w-[210px] md:w-[525px] text-13 sm:text-15 md:text-37 font-preBold'>공사업체</div>
            {!viewCnstrCmpny && <IoIosArrowDown className='mr-18 md:mr-[45px] md:w-[40px] md:h-[40px]' />}
            {viewCnstrCmpny && <IoIosArrowUp className='mr-18 md:mr-[45px] md:w-[40px] md:h-[40px]' />}
          </button>
          {viewCnstrCmpny &&
            <div className='flex mt-20 text-14 md:mt-[50px] md:text-35'>
              <div className='font-preBold'>
                <p className='ml-10 sm:ml-14 md:ml-[35px] mb-15 md:mb-[37px]'>전기시설</p>
                <p className='ml-10 sm:ml-14 md:ml-[35px] mb-15 md:mb-[37px] tracking-tight'>바닥(카페트)</p>
                <p className='ml-10 sm:ml-14 md:ml-[35px] mb-15 md:mb-[37px]'>도배시공</p>
                <p className='ml-10 sm:ml-14 md:ml-[35px] mb-15 md:mb-[37px]'>방염</p>
                <p className='ml-10 sm:ml-14 md:ml-[35px] mb-15 md:mb-[37px]'>철거</p>
              </div>
              <div className='font-preLight w-[70%]'>
                <p className='mb-15 md:mb-[37px] truncate'>-</p>
                <p className='mb-15 md:mb-[37px] truncate'>-</p>
                <p className='mb-15 md:mb-[37px]'>-</p>
                <p className='mb-15 md:mb-[37px]'>-</p>
                <p className='mb-15 md:mb-[37px]'>-</p>
              </div>
            </div>}
        </>}
        <button onClick={() => setViewFldAgnt(!viewFldAgnt)} className='mt-24 flex justify-between items-center outline-none border-none w-full h-47 md:h-[117px] rounded-[5px]  md:rounded-[12px] shadow-[0_0_3px_1px_rgba(0,0,0,0.10)]'>
          <div className='flex flex-col justify-center items-start pl-18 md:pl-[45px] w-[155px] sm:w-[210px] md:w-[525px] text-13 sm:text-15 md:text-37 font-preBold'>현장 대리인</div>
          {!viewFldAgnt && <IoIosArrowDown className='mr-18 md:mr-[45px] md:w-[40px] md:h-[40px]' />}
          {viewFldAgnt && <IoIosArrowUp className='mr-18 md:mr-[45px] md:w-[40px] md:h-[40px]' />}
        </button>
        {viewFldAgnt &&
          <table className='table-fixed w-[260px] sm:w-[318px] md:w-[750px] overflow-auto mt-24 md:mt-[60px]'>
            <tbody>
              <tr className='bg-[#F6F7F9] h-45 md:h-[112px] text-12 sm:text-13 md:text-32 leading-15 md:leading-37 border border-x-0 border-[#CACACA]'>
                <td className='align-middle text-center w-60 sm:w-80 '>성명</td>
                <td className='align-middle text-center w-40 sm:w-65 '>직책</td>
                <td className='align-middle text-center w-90 sm:w-110 '>휴대폰번호</td>
              </tr>
              {fldAgntDataList.map((agnt: any, idx: number) => {
                return (
                  <tr key={idx} className='h-54 md:h-[135px] text-12 sm:text-14 md:text-35 leading-17 md:leading-[42px] font-preLight border border-x-0 border-t-0 border-[#CACACA]'>
                    <td className='align-middle text-center truncate'>{agnt.name}</td>
                    <td className='align-middle text-center truncate'>{agnt.position}</td>
                    <td className='align-middle text-center'>{`${agnt.phone}`}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>}
        <button onClick={() => setViewWrkrList(!viewWrkrList)} className='mt-24 md:mt-[60px] flex justify-between items-center outline-none border-none w-full h-47 md:h-[117px] rounded-[5px]  md:rounded-[12px] shadow-[0_0_3px_1px_rgba(0,0,0,0.10)]'>
          <div className='flex flex-col justify-center items-start pl-18 md:pl-[45px] w-[155px] sm:w-[210px] md:w-[525px] text-13 sm:text-15 md:text-37 font-preBold'>작업자 명단</div>
          {!viewWrkrList && <IoIosArrowDown className='mr-18 md:mr-[45px] md:w-[40px] md:h-[40px]' />}
          {viewWrkrList && <IoIosArrowUp className='mr-18 md:mr-[45px] md:w-[40px] md:h-[40px]' />}
        </button>
        {viewWrkrList &&
          <table className='table-fixed w-[260px] sm:w-[318px] md:w-[750px] overflow-auto mt-24 md:mt-[60px]'>
            <tbody>
              <tr className='bg-[#F6F7F9] h-45 md:h-[112px] text-12 sm:text-13 md:text-32 leading-15 md:leading-37 border border-x-0 border-[#CACACA]'>
                <td className='align-middle text-center w-30 sm:w-50'>No</td>
                <td className='align-middle text-center w-70 sm:w-95'>성명</td>
                <td className='align-middle text-center w-90 sm:w-115'>휴대폰번호</td>
              </tr>
              {wrkrInfoDataList.length === 0
                ? <tr className='h-54 md:h-[135px] text-12 sm:text-14 md:text-35 leading-17 md:leading-[42px] font-preLight border border-x-0 border-t-0 border-[#CACACA]'>
                  <td colSpan={3} className='align-middle text-center'>조회된 작업자가 없습니다.</td>
                </tr>
                : wrkrInfoDataList.map((wrkr: any, idx: number) => {
                  return (
                    <tr key={idx} className='h-54 md:h-[135px] text-12 sm:text-14 md:text-35 leading-17 font-preLight border border-x-0 border-t-0 border-[#CACACA]'>
                      <td className='align-middle text-center'>{idx + 1}</td>
                      <td className='align-middle text-center truncate'>{wrkr.name}</td>
                      <td className='align-middle text-center'>{`${wrkr.phone}`}</td>
                    </tr>
                  );
                })}
            </tbody>
          </table>}
        <button onClick={() => setViewWrkCntns(!viewWrkCntns)} className='mt-24 md:mt-[60px] flex justify-between items-center outline-none border-none w-full h-47 md:h-[117px] rounded-[5px] md:rounded-[12px] shadow-[0_0_3px_1px_rgba(0,0,0,0.10)]'>
          <div className='flex flex-col justify-center items-start pl-18 md:pl-[45px] w-[155px] sm:w-[210px] md:w-[525px] text-13 sm:text-15 md:text-37 font-preBold'>작업 내용</div>
          {!viewWrkCntns && <IoIosArrowDown className='mr-18 md:mr-[45px] md:w-[40px] md:h-[40px]' />}
          {viewWrkCntns && <IoIosArrowUp className='mr-18 md:mr-[45px] md:w-[40px] md:h-[40px]' />}
        </button>
        {viewWrkCntns && <>
          {dngrEvalDataList.length > 0 ? dngrEvalDataList.map((data: any) => {
            return (
              <table key={data.seq} className='table-fixed w-full overflow-auto mt-24 md:mt-[60px]'>
                <tbody>
                  <tr className='h-36 md:h-[90px] border border-x-0 border-[#CACACA]'>
                    <td colSpan={3} className='bg-[#F6F6F8] align-middle text-center text-13 md:text-32 leading-15 md:leading-37'>세부작업</td>
                    <td colSpan={13} className='pl-10 md:pl-[25px] font-preLight text-14 leading-16 md:text-35 md:leading-[40px]'>{data.dtlWrk}</td>
                  </tr>
                  <tr className='h-36 md:h-[90px] border border-x-0 border-[#CACACA]'>
                    <td colSpan={3} className='bg-[#F6F6F8] align-middle text-center text-13 md:text-32 leading-15 md:leading-37'>위험요인</td>
                    <td colSpan={13} className='pl-10 md:pl-[25px] font-preLight text-14 leading-16 md:text-35 md:leading-[40px]'>{data.dngrRsn}</td>
                  </tr>
                  <tr className='h-36 md:h-[90px] text-14 leading-16 md:text-35 md:leading-[40px] border border-x-0 border-t-0 border-[#CACACA]'>
                    <td colSpan={3} className='bg-[#F6F6F8] align-middle text-center text-13 md:text-32 leading-15 md:leading-37'>빈도</td>
                    <td colSpan={2} className='text-center font-preLight text-14 leading-16 md:text-35 md:leading-[40px]'>{data.dngrFrqncy}</td>
                    <td colSpan={3} className='bg-[#F6F6F8] align-middle text-center text-13 md:text-32 leading-15 md:leading-37'>강도</td>
                    <td colSpan={2} className='text-center font-preLight text-14 leading-16 md:text-35 md:leading-[40px]'>{data.dngrIntnsty}</td>
                    <td colSpan={3} className='bg-[#F6F6F8] align-middle text-center text-13 md:text-32 leading-15 md:leading-37'>위험도</td>
                    <td colSpan={3}
                      className={data.dngrScor === 9 ? 'bg-[#FFEEEF] text-[#EA505E] text-center font-preLight text-14 leading-16 md:text-35 md:leading-[40px]'
                        : data.dngrScor <= 6 && data.dngrScor >= 4 ? 'text-[#FFB237] bg-[#FFFAE0] text-center font-preLight text-14 leading-16 md:text-35 md:leading-[40px]'
                          : 'text-[#5DB202] bg-[#F4FBE9] text-center font-preLight text-14 leading-16 md:text-35 md:leading-[40px]'}>
                      {data.dngrScor}{data.dngrScor === 9 ? '(높음)' : data.dngrScor <= 6 && data.dngrScor >= 4 ? '(보통)' : '(낮음)'}
                    </td>
                  </tr>
                  <tr className='h-36 md:h-[90px] border border-x-0 border-[#CACACA]'>
                    <td colSpan={3} className='bg-[#F6F6F8] align-middle text-center text-13 md:text-32 leading-15 md:leading-37'>감소대책</td>
                    <td colSpan={13} className='pl-10 md:pl-[25px] font-preLight text-14 leading-16 md:text-35 md:leading-[40px]'>{data.rdctMsr}</td>
                  </tr>
                </tbody>
              </table>
            )
          }) : <p className={`mt-15 ml-15 md:mt-[37px] md:ml-[37px] text-15 leading-18 md:text-37 md:leading-[45px] font-normal truncate`}>등록된 위험요인이 없습니다.</p>
          }
          {dngrEvalDataList.length > 0 &&
            <table className='table-fixed w-[265px] sm:w-[318px] md:w-[750px] overflow-auto mt-24 md:mt-[60px]'>
              <tbody>
                <tr className='bg-[#F6F7F9] h-36 md:h-[90px] text-12 sm:text-13 md:text-32 leading-15 md:leading-[37px] border border-x-0 border-[#CACACA]'>
                  <td className='align-middle text-center'>작업장소</td>
                </tr>
                <tr className='border border-x-0 border-t-0 border-[#CACACA]'>
                  <td className='algin-middle text-center relative'>
                    <img ref={mapRef} className='object-cover' src={placeSrc} alt='map' data-ge-place-image="true" />

                    {dngrEvalDataList.map((data: any, i1: number) => {
                      if (data.workPlc) {
                        var arr = eval(data.workPlc)
                        return <React.Fragment key={i1}>
                          {arr.map((point: any, i2: number) =>
                            <div key={i2}
                              data-tooltip-id="tooltip"
                              data-tooltip-content={data.dtlWrk + '(위험도:' + (data.dngrScor === 9 ? '높음' : data.dngrScor <= 6 && data.dngrScor >= 4 ? '보통' : '낮음') + ')'}
                              className='ge-mark-01' data-work-plc-x={point[0]} data-work-plc-y={point[1]} data-ge-place-point="true" style={{ display: "none" }} />
                          )}
                          <Tooltip id="tooltip" />
                        </React.Fragment>
                      }
                    })}
                  </td>
                </tr>
              </tbody>
            </table>}
        </>}
        <button onClick={() => setViewMemo(!viewMemo)} className='mt-24 md:mt-[60px] flex justify-between items-center outline-none border-none w-full h-47 md:h-[117px] rounded-[5px] md:rounded-[12px] shadow-[0_0_3px_1px_rgba(0,0,0,0.10)]'>
          <div className='flex flex-col justify-center items-start pl-18 md:pl-[45px] w-[155px] sm:w-[210px] md:w-[525px] text-13 sm:text-15 md:text-37 font-preBold'>메모</div>
          {!viewMemo && <IoIosArrowDown className='mr-18 md:mr-[45px] md:w-[40px] md:h-[40px]' />}
          {viewMemo && <IoIosArrowUp className='mr-18 md:mr-[45px] md:w-[40px] md:h-[40px]' />}
        </button>
        {viewMemo &&
          <div className='mt-23 md:mt-[57px] bg-[#F6F6F8] w-full h-100 md:h-[250px] overflow-auto scrollbar-hide px-9 py-9 md:px-[22px] md:py-[22px] text-14 leading-16 md:text-35 md:leading-[40px] rounded-[5px] md:rounded-[12px]'>{apprMemo}</div>
        }
      </div>
      <button
        onClick={() => setTab('list')}
        className='font-preLight text-15 md:text-37 text-white w-[318px] xxsm:w-[265px] h-43 outline-none bg-gradient-to-r from-gdFrom to-gdTo rounded-[5px] md:rounded-[12px] mt-auto pt-10 pb-10 mb-20 md:pt-[25px] md:pb-[25px] md:mb-[50px]'>확인</button>
    </div>
  );
}

const fn_retrieveDngrEvalDtl = async ({ wrkDclrSeq, setFldAgntDataList, setWrkrInfoDataList, setMainDtlData, setFileDataList, setDngrEvalDataList, setIsExhibition, setApprMemo }: any) => {
  let rtrnData = await axios.post('admin/api/dngrEval/retrieveDngrEvalDtlData', { wrkDclrSeq: wrkDclrSeq })
  const mainDtlData = rtrnData.data.mainDtlData;
  let lastmemo = await axios.post('admin/api/dngrEval/retrieveWrkPrcsLastMemo', { wrkDclrSeq: wrkDclrSeq })
  setApprMemo(lastmemo.data);
  if (mainDtlData.sctrGbNm === '전시디자인설치') {
    setIsExhibition(true);
  }
  const siteUserDataList = rtrnData.data.siteUserDataList;
  const wrkrUserDataList = rtrnData.data.wrkrUserDataList;
  const dngrEvalDataList = rtrnData.data.dngrEvalDataList;
  setFldAgntDataList(siteUserDataList);
  setWrkrInfoDataList(wrkrUserDataList);
  const atchFileId = mainDtlData.atchFileId;
  rtrnData = await axios.post('admin/api/cmmn/fileInfoForTableView', { atchFileId: atchFileId })
  const atchFileData = rtrnData.data;
  setMainDtlData(mainDtlData);
  setFileDataList(atchFileData.fileList);
  setDngrEvalDataList(dngrEvalDataList);
}
